import { PvpLibraryActions } from "../actions/pvp-library.actions";

const initialState = {
  pvp_card: {},
  filter_obj: {},
  entity_column_values: [],
  pvp_library_msg: "",
};

/**
 * Reducer function to manage the state of the PVP library.
 * 
 * This function handles various actions related to the PVP library state, 
 * including setting the PVP card, updating the filter object, managing 
 * entity column values, and setting library messages.
 *
 * @param {Object} state - The current state of the PVP library.
 * @param {Object} action - The action dispatched to the reducer.
 * @returns {Object} The updated state based on the action type.
 *
 * Actions handled:
 * - `SET_PVP_CARD`: Updates the PVP card data in the state.
 * - `SET_FILTEROBJECT`: Sets the filter object for the PVP library.
 * - `SET_FILTER_ENTITY_COLUMN_VALUES`: Sets the filter entity column values.
 * - `UPDATE_FILTER_ENTITY_COLUMN_VALUES`: Updates the filter entity column values.
 * - `CLEAR_FILTER_ENTITY_COLUMN_VALUES`: Clears the filter entity column values.
 * - `SET_PVP_LIBRARY_MESSAGE`: Sets the PVP library message.
 */

export const pvpLibraryState = (state = initialState, action: any) => {
  switch (action.type) {
    case PvpLibraryActions.SET_PVP_CARD:
      return {...state, ...{ pvp_card: action.payload.pvp_card }};

    case PvpLibraryActions.SET_FILTEROBJECT:
      return {
        ...state,
        filter_obj: { ...state.filter_obj, ...action.payload.filter_column },
      };

    case PvpLibraryActions.SET_FILTER_ENTITY_COLUMN_VALUES:{
      let entity_column: any = [...state.entity_column_values];
      entity_column[action.payload.entity_index] = {
        ...entity_column[action.payload.entity_index],
        ...action.payload.filter_column,
      };

      return {...state, ...{ entity_column_values: entity_column }};
    }
    case PvpLibraryActions.UPDATE_FILTER_ENTITY_COLUMN_VALUES:{
      let updated_column: any = [...state.entity_column_values];
      for (let col in updated_column[action.payload.entity_index]) {
        if (col !== action.payload.filter_column) {
          delete updated_column[action.payload.entity_index][col];
        }
      }
      return {...state, ...{ entity_column_values: updated_column }};
    }
    case PvpLibraryActions.CLEAR_FILTER_ENTITY_COLUMN_VALUES:
      return {...state, ...{
        entity_column_values: action.payload.entity_column,
      }};

    case PvpLibraryActions.SET_PVP_LIBRARY_MESSAGE:
      return {...state, ...{
        pvp_library_msg: action.payload.pvp_library_msg,
      }};

    default:
      return state;
  }
};